import { render, staticRenderFns } from "./swiperBanner.vue?vue&type=template&id=ec2a30cc&scoped=true"
import script from "./swiperBanner.vue?vue&type=script&lang=js"
export * from "./swiperBanner.vue?vue&type=script&lang=js"
import style0 from "./swiperBanner.vue?vue&type=style&index=0&id=ec2a30cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2a30cc",
  null
  
)

export default component.exports